<div *ngIf="mainService.lojaService.processando" class="text-center">
    <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>

<div *ngIf="!mainService.lojaService.processando">
    <div *ngIf="!mainService.lojaCarrinho.parceiro || exibeListaParceiros" class="container">

        <div
            *ngIf="mainService.parceiroService.getParceirosLoja() !== undefined && mainService.parceiroService.getParceirosLoja().length === 0">
            <p>Desculpe!</p>
            <p>Ainda não há Produtos disponíveis para sua campanha!</p>
            <p>Caso tenha dúvidas, por favor entre em contato com nosso SAC!</p>
            <p>Obrigado!</p>
        </div>

        <div
            *ngIf="mainService.parceiroService.getParceirosLoja() !== undefined && mainService.parceiroService.getParceirosLoja().length > 0">

            <div class="col-12 app-parceiro-descricao">
                <p>Escolha um dos nossos parceiros e-commerce e <br>
                    resgate aquele produto que você tanto deseja!</p>
            </div>

            <div class="col-xs-12 col-md-10 col-md-offset-1 text-center">
                <div class="app-parceiro-loja" *ngFor="let parceiro of mainService.parceiroService.getParceirosLoja()">
                    <a (click)="selecionarParceiro(parceiro)" class="text-center"
                        style="margin: 10px; cursor: pointer;">
                        <img [src]="parceiro.logotipoGrande" [alt]="parceiro.nome" [id]="parceiro.nome">
                    </a>
                </div>
            </div>
        </div>

        <div class="col-xs-12 text-center">
            <button *ngIf="mainService.lojaCarrinho.parceiro" (click)="exibeListaParceiros = false"
                class="btn app-btn-best">Cancelar</button>
        </div>
    </div>


    <div *ngIf="mainService.lojaCarrinho.parceiro && !exibeListaParceiros">
        <div class="hold">
            <div id="menu-loja" class="menu" [ngClass]="{'activeMenu': aberto,'':!aberto }">
                <button id="fecha" (click)="abrir()" class="pull-right btn app-btn-best app-btn-mobile">
                    <span class="btn glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                </button>

                <!-- <div *ngIf="mainService.lojaService.departamentos !== undefined && mainService.lojaService.departamentos.length" class="menu-estrutura"> -->
                <div class="menu-estrutura">
                    <div class="app-lojaParceiro">
                        <h6>Clique e selecione um de nossos Parceiros:</h6>
                        <img [src]="mainService.lojaCarrinho.parceiro.logotipo" (click)="exibeListaParceiros = true;"
                            id="imagem-parceiro" class="app-selecionar-parceiro">
                    </div>

                    <div *ngIf="!mainService.lojaService.categoriaSelecionada">
                        <ul class="lstNavMain">
                            <li *ngFor="let departamento of mainService.lojaService.departamentos">
                                <a (click)="carregarSubCategorias(departamento)"
                                    id="departamento-{{ departamento.nome }}">
                                    {{ departamento.nome }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div *ngIf="mainService.lojaService.categoriaSelecionada">
                        <ul class="lstNavMain">
                            <li id="btn-departamentos" class="btn-departamento">
                                <a (click)="goVitrine(mainService.lojaCarrinho.parceiro);">
                                    <i class="fa fa-bars" aria-hidden="true"></i> Departamentos
                                </a>
                            </li>

                            <li *ngFor="let categoria of mainService.lojaService.categorias">
                                <a (click)="carregarSubCategorias(categoria)">{{ categoria.nome }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!--Menu FECHADO-->
            <div class="hold">
                <div class="header container-fluid">
                    <button id="abre" class="btn app-btn-best app-btn-mobile pull-left" (click)="abrir()">
                        <span>Departamentos </span>
                    </button>

                    <a (click)="router.navigate(['/loja/carrinho'])"
                        class="btn app-btn-best app-btn-mobile pull-right visible-xs">
                        <i class="fa fa-shopping-cart"></i>
                        <span
                            *ngIf="mainService.lojaCarrinho.itens !== undefined && mainService.lojaCarrinho.itens.length"
                            class="badge">
                            {{ mainService.lojaCarrinho.itens.length }}
                        </span>
                    </a>
                </div>
            </div>
            <!--Fim do menu-->
        </div>

        <div class="app-produtos-vitrine" [ngClass]="{'is-hidden': aberto, '' : !aberto}"
            *ngIf="mainService.lojaService.departamentos !== undefined && mainService.lojaService.departamentos.length">
            <div class="col-xs-12" style="margin-top: 10px;">

                <ol class="breadcrumb text-left" style="font-size: x-small !important;">
                    <span class="app-texto-cor-azul"> Você esta em:</span>
                    <li class="active"><a (click)="goVitrine(mainService.lojaCarrinho.parceiro)">
                            Departamentos
                        </a>
                    </li>
                    <li *ngFor="let categoria of breadcrumbCategorias">
                        <a (click)="carregarSubCategorias(categoria)">{{ categoria.nome }}</a>
                    </li>
                </ol>

                <div class="col-xs-12 col-md-6">
                    <div class="form-group">
                        <div class="input-group">
                            <input type="text" id="busca" [(ngModel)]="termoBusca" uiEnter="btn-busca"
                                class="form-control" placeholder="Ex:Livro">
                            <span class="input-group-btn">
                                <button class="btn app-btn-best" type="button" (click)="buscarPorTermo()"
                                    id="btn-busca">
                                    <i class="fa fa-search"></i>
                                </button>
                            </span>
                        </div>

                        <div class="checkbox" *ngIf="mainService.lojaService.categoriaSelecionada">
                            <label>
                                <input type="checkbox" [(ngModel)]="pesquisarNaCategoriaAtual">
                                Pesquisar na categoria atual?
                            </label>
                        </div>
                    </div>
                </div>

                <div class=" col-xs-12 col-sm-10 col-md-3">
                    <div class="form-group">
                        <select class="form-control" id="orderBy" [(ngModel)]="opcaoOrdenacao"
                            (ngModelChange)="resetLimitePorPagina()">
                            <option *ngFor="let opcaoOrdenacao of opcoesOrdenacao | keyOfValue ">
                                {{ opcaoOrdenacao.value }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-xs-2 hidden-xs">
                    <a (click)="router.navigate(['/loja/carrinho'])" class="btn app-btn-best pull-right">
                        <i class="fa fa-2x fa-shopping-cart"></i>
                        <span
                            *ngIf="mainService.lojaCarrinho.itens !== undefined && mainService.lojaCarrinho.itens.length"
                            class="badge">
                            {{ mainService.lojaCarrinho.itens.length }}
                        </span>
                    </a>
                </div>
            </div>
        </div>

        <div class="app-produtos-vitrine" [ngClass]="{'is-hidden': aberto,'':!aberto }" *ngIf="!produtoSelecionado">
            <h4 class="text-left" id="{{ mainService.lojaService.categoriaSelecionada.nome }}"
                *ngIf="mainService.lojaService.categoriaSelecionada !== undefined">
                {{ mainService.lojaService.categoriaSelecionada.nome }}
            </h4>

            <div *ngIf="mainService.lojaService.produtos !== undefined && !mainService.lojaService.produtos.length">
                <h3>Nenhum produto encontrado!</h3>
                Dica: tente procurar por outro termo.
            </div>

            <div *ngIf="mainService.lojaService.produtos !== undefined && mainService.lojaService.produtos.length">
                <div *ngFor=" let produto of mainService.lojaService.produtos| orderBy:opcaoOrdenacao  | slice:0:limitePorPagina"
                    (click)="selecionarProduto(produto)" class="app-produto-grade">
                    <div class="app-produto-grade-titulo">
                        {{ produto.nome }}
                    </div>

                    <div class="app-produto-img-grade">
                        <img [src]="produto.url">
                    </div>

                    <div *ngIf="produto.disponivel" class="app-produto-grade-detalhes">
                        <div class="app-texto-pontos"> {{ produto.pontos }} </div>
                        Pontos
                    </div>

                    <div *ngIf="!produto.disponivel" class="app-produto-grade-detalhes">
                        <span class="label label-danger">Indisponível</span>
                    </div>
                </div>

                <div class="col-xs-12 text-center">
                    <br>
                    <br>

                    <button (click)="carregarMaisProdutos()"
                        *ngIf="mainService.lojaService.produtos !== undefined && limitePorPagina < mainService.lojaService.produtos.length"
                        class="btn app-btn-best">carregar mais produtos</button>
                </div>
            </div>
        </div>

        <div class="app-produtos-vitrine" [ngClass]="{'is-hidden': aberto,'':!aberto }" *ngIf="produtoSelecionado">

            <div class="col-xs-12 col-sm-6">
                <h3 style="margin-top: 20px;" class="visible-xs">
                    {{produtoSelecionado.nome}}
                </h3>
                <div class="col-xs-12 col-md-11 col-md-offset-1 app-produto-selecionado-img-principal">
                    <img [src]="produtoSelecionado.imagemSelecionada ? produtoSelecionado.imagemSelecionada : produtoSelecionado.imagens[0]"
                        class="app-img" style="max-height: 300px">
                </div>
                <div class="col-xs-12 col-md-11 col-md-offset-1">
                    <div *ngIf="produtoSelecionado.descricao && produtoSelecionado.imagens.length > 1 ">
                        <a *ngFor="let imagem of produtoSelecionado.imagens | limitTo:4"
                            (click)="produtoSelecionado.imagemSelecionada = imagem">
                            <img [src]="imagem" class="app-produto-selecionado-galeria">
                        </a>
                    </div>

                    <div *ngIf="!produtoSelecionado.descricao" class="app-produtos-vitrine text-center">
                        <i class="fa fa-spinner fa-pulse fa-4x"></i>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-5">
                <div class="col-xs-12 col-md-11 col-md-offset-1 app-produto-selecionado-box">
                    <h3 style="margin-top: 20px;" class="hidden-xs">
                        {{ produtoSelecionado.nome }}
                    </h3>
                    <div *ngIf="!processandoProdutoSelecionadoValor && produtoSelecionado.disponivel"
                        class="app-produto-selecionado-painel">
                        <div class="app-produto-selecionado-pontos">{{produtoSelecionado.pontos}}</div>
                        <span class="preto">Pontos</span>
                    </div>
                    <div *ngIf="processandoProdutoSelecionadoValor" class="app-produtos-vitrine text-center">
                        <i class="fa fa-spinner fa-pulse fa-4x"></i>
                    </div>
                </div>

                <div *ngIf="!produtoSelecionado.disponivel" class="text-center">
                    <span class="label label-danger">Indisponível</span>
                </div>

                <div *ngIf="!processandoProduto && produtoSelecionado.disponivel && produtoSelecionado.pontos && produtoSelecionado.pontos > 0"
                    class="form-group app-produto-selecionado-botoes">
                    <button class="btn app-btn-best btn-block" (click)="adicionarAoCarrinho()"
                        id="btn-adicionar-carrinho">
                        Adicionar ao carrinho
                    </button>

                    <br>

                    <button class="btn app-btn-best btn-block" (click)="irAoCarrinho()" id="btn-resgatar-produto">
                        Resgatar
                    </button>
                </div>

                <div *ngIf="processandoProduto" class="app-produtos-vitrine text-center">
                    <i class="fa fa-spinner fa-pulse fa-4x"></i>
                </div>
            </div>

            <div class="col-xs-12">
                <h3>Descrição</h3>
                <hr>
            </div>

            <div *ngIf="produtoSelecionado.descricao" class="col-xs-12 app-produto-selecionado-descricao"
                [innerHtml]="produtoSelecionado.descricao">
            </div>

            <div *ngIf="!produtoSelecionado.descricao" class="app-produtos-vitrine text-center">
                <i class="fa fa-spinner fa-pulse fa-4x"></i>
            </div>

            <div class="col-xs-12" style="margin-top: 1em;">
                <button class="btn app-btn-best" (click)="deselecionarProduto()">
                    Voltar a lista de produtos
                </button>
            </div>
        </div>
    </div>
</div>
<div class="clearfix"></div>


// WEBPACK FOOTER //
// ./src/app/loja/loja-vitrine/loja-vitrine.component.html